var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.banner)?_c('div',{staticClass:"banner",class:{
    'banner--animated': _vm.banner.hasAnimated,
    'banner--hidden': _vm.shouldHide,
  }},[_c('div',{staticClass:"banner__inner"},[_c('p',{staticClass:"banner__lead"},[_vm._v(" "+_vm._s(_vm.banner.title)+" ")]),(_vm.banner.action)?_c('button',{staticClass:"button-reset banner__button",attrs:{"type":"button"},on:{"click":_vm.handleAction}},[_c('span',[_vm._v(_vm._s(_vm.banner.action.title))]),_c('MoveRight')],1):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }